import _toConsumableArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "open", "onRequestClose", "triggerId"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuContainer } from "./dropdown-menu.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var menuItemSelector = '[role="menuitem"]';
var focusToNextElement = function focusToNextElement(_ref2) {
  var menuItems = _ref2.menuItems,
    activeElement = _ref2.activeElement,
    direction = _ref2.direction;
  var _nextElement$focus;
  if (!menuItems || !activeElement || menuItems.length === 1) {
    return;
  }
  var activeIndex = menuItems.indexOf(activeElement);
  var lastIndex = menuItems.length - 1;
  var nextIndex = activeIndex + direction;
  nextIndex = nextIndex > lastIndex ? 0 : nextIndex;
  nextIndex = nextIndex < 0 ? lastIndex : nextIndex;
  var nextElement = menuItems[nextIndex];
  nextElement === null || nextElement === void 0 ? void 0 : (_nextElement$focus = nextElement.focus) === null || _nextElement$focus === void 0 ? void 0 : _nextElement$focus.call(nextElement);
};
var DropdownMenu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    open = _ref.open,
    onRequestClose = _ref.onRequestClose,
    triggerId = _ref.triggerId,
    props = _objectWithoutProperties(_ref, _excluded);
  var menuContainerRef = useRef(null);
  useImperativeHandle(ref, function () {
    return menuContainerRef.current;
  });
  var handleRequestClose = useCallback(function () {
    var _dropdownTrigger$focu;
    var dropdownTrigger = document.getElementById(triggerId);
    dropdownTrigger === null || dropdownTrigger === void 0 ? void 0 : (_dropdownTrigger$focu = dropdownTrigger.focus) === null || _dropdownTrigger$focu === void 0 ? void 0 : _dropdownTrigger$focu.call(dropdownTrigger);
    onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
  }, [onRequestClose, triggerId]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      var dropdownTrigger = document.getElementById(triggerId);
      if (menuContainerRef.current && !menuContainerRef.current.contains(event.target) && !dropdownTrigger.contains(event.target)) {
        handleRequestClose();
      }
    };
    var handleKeyboardAction = function handleKeyboardAction(event) {
      var _document;
      if (event.defaultPrevented) {
        return;
      }
      var menuItems = menuContainerRef.current.querySelectorAll(menuItemSelector);
      menuItems = menuItems ? _toConsumableArray(menuItems) : null;
      var activeElement = (_document = document) === null || _document === void 0 ? void 0 : _document.activeElement;
      switch (event.key) {
        case 'ArrowDown':
          focusToNextElement({
            menuItems: menuItems,
            activeElement: activeElement,
            direction: 1
          });
          break;
        case 'ArrowUp':
          {
            focusToNextElement({
              menuItems: menuItems,
              activeElement: activeElement,
              direction: -1
            });
            break;
          }
        case 'Escape':
        case 'Tab':
          handleRequestClose();
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    if (open) {
      var _menuItem$focus;
      var menuItem = menuContainerRef.current.querySelector(menuItemSelector);
      menuItem === null || menuItem === void 0 ? void 0 : (_menuItem$focus = menuItem.focus) === null || _menuItem$focus === void 0 ? void 0 : _menuItem$focus.call(menuItem);
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyboardAction);
    }
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyboardAction);
    };
  }, [open, handleRequestClose, triggerId]);
  return /*#__PURE__*/_jsx(DropdownMenuContainer, _objectSpread(_objectSpread({
    ref: menuContainerRef,
    role: "menu",
    tabIndex: -1,
    open: open,
    "aria-labelledby": triggerId
  }, props), {}, {
    children: open && children
  }));
});
DropdownMenu.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  triggerId: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  alignment: PropTypes.oneOf(['left', 'center', 'right'])
};
DropdownMenu.defaultProps = {
  open: false,
  onRequestClose: undefined,
  alignment: 'center'
};
export default DropdownMenu;